import React, { Component } from "react";
import WorkingHoursContainer from "./WorkingHoursContainer";
import ServicesContainer from "./ServicesContainer";

const index = ({ operations, services }) => (
  <div className="row">
    <div className="col-md-6 foot-box mb-2">
      <h2>Service</h2>
      {services ? <ServicesContainer services={services} /> : <div>Services Not Added</div>}
    </div>
    <div className="col-md-6 foot-box">
      <h2>Working Hours</h2>
      {operations ? (
        <WorkingHoursContainer operations={operations} />
      ) : (
        <div>Working Hours Not Added</div>
      )}
    </div>
  </div>
);

export default index;



// WEBPACK FOOTER //
// ./components/ServiceBottom/index.js